// ------------------------------------
// Constants
// ------------------------------------
// prettier-ignore
export const APPLICATIONS_POST_REQUEST = 'APPLICATIONS_POST_REQUEST';
// prettier-ignore
export const APPLICATIONS_POST_REQUEST_SUCCESS = 'APPLICATIONS_POST_REQUEST_SUCCESS';
// prettier-ignore
export const APPLICATIONS_POST_REQUEST_FAILURE = 'APPLICATIONS_POST_REQUEST_FAILURE';

// ------------------------------------
// Actions
// ------------------------------------
export function request(payload, resolve, reject) {
  return {
    type: APPLICATIONS_POST_REQUEST,
    payload,
    resolve,
    reject,
  };
}

export function requestSuccess(data) {
  return {
    type: APPLICATIONS_POST_REQUEST_SUCCESS,
    data,
  };
}

export function requestFailure(error) {
  return {
    type: APPLICATIONS_POST_REQUEST_FAILURE,
    error,
  };
}
